export default "__VITE_ASSET__Cv1iisY3__"